export default __webpack_public_path__ + "static/media/podcasts.bfbb0be8.svg";